module.exports = __webpack_public_path__ + "img/ignis-banner.3318c735.svg";